const urlParams = new URLSearchParams(window.location.search);
const action = urlParams.get('action');
const checkemail = urlParams.get('checkemail');

if (action === 'lostpassword') {
    alterLostPasswordPageContent();
} else if (action === 'rp') {
    alterNewPasswordPageContent();
} else if (action === 'resetpass') {
    alterSuccessfulPasswordChangePageContent();
}

if (checkemail === 'confirm') {
    // This is the "success" state of "lostpassword" form
    alterEmailConfirmPageContent();
}

function createTargeter(scope) {
    return function target(selector) {
        return document.querySelector(`${scope} ${selector}`);
    }
}

function alterLostPasswordPageContent() {
    const target = createTargeter('body.login-action-lostpassword');

    // Replace logo with custom title
    const pageTitle = target('h1');
    pageTitle.innerHTML = slLogin.strings.titleReset;

    // Remove default form instruction
    const mainContent = target('#login');
    const defaultInstruction = target('#login p.message');
    mainContent.removeChild(defaultInstruction);

    // Add custom form instruction
    const customInstruction = document.createElement('p');
    customInstruction.classList.add('custom-instruction');
    customInstruction.textContent = slLogin.strings.contentReset;

    const mainForm = target('#lostpasswordform');
    mainForm.prepend(customInstruction);

    // Add a placeholder text to input box
    const emailInput = target('input[name="user_login"]');
    emailInput.placeholder = slLogin.strings.placeholder

    // The default submit button text is too wide for 320px screen.
    const submitButton = target('input#wp-submit');
    submitButton.value = slLogin.strings.button;

    // Move error message to inside the "card", if any
    const errorMessage = target('#login_error');
    if (errorMessage !== null) {
        errorMessage.parentElement.removeChild(errorMessage);
        mainForm.prepend(errorMessage);
    }

    // Remove the link to the default login page
    const linkToLoginPage = target('p#nav a[href$="wp-login.php"]');
    linkToLoginPage.parentElement.removeChild(linkToLoginPage);
}

function alterNewPasswordPageContent() {
    const target = createTargeter('body.login-action-rp');

    // Replace logo with custom title
    const pageTitle = target('h1');
    pageTitle.innerHTML = slLogin.strings.titleNew;

    // Remove default form instruction
    const defaultInstruction = target('#login p.message');
    defaultInstruction.parentElement.removeChild(defaultInstruction);

    // Add custom form instruction
    const customInstruction = document.createElement('p');
    customInstruction.classList.add('custom-instruction');
    customInstruction.textContent = slLogin.strings.contentNew;

    const mainForm = target('#resetpassform');
    mainForm.prepend(customInstruction);

    // Remove the link to the default login page
    const linkToLoginPage = target('p#nav a[href$="wp-login.php"]');
    linkToLoginPage.parentElement.removeChild(linkToLoginPage);
}

function alterSuccessfulPasswordChangePageContent() {
    const target = createTargeter('body.login-action-resetpass');

    // Replace logo with custom title
    const pageTitle = target('h1');
    pageTitle.innerHTML = slLogin.strings.titleNew;

    // Change confirmation message
    const message = target('p.message');
    message.innerHTML = slLogin.strings.confirmPassword;
}

function alterEmailConfirmPageContent() {
    const target = createTargeter('body.login-action-checkemail');

    // Replace logo with custom title
    const pageTitle = target('h1');
    pageTitle.innerHTML = slLogin.strings.titleReset;

    // Change confirmation message
    const message = target('p.message');
    message.textContent = slLogin.strings.confirmEmail;
}
